<template>
	<section>
		<header-page
			actions
			name="account-definitions"
			:title="title"
			@run-action="runAction"
		/>
		<rules-list
			v-if="currentSubsidiary.id"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="rows.length"
			:current-page="params.page"
			:last-page="table.lastPage"
			:rows="rows"
			@click-icon="clickIcon"
			@on-page="onPage"
			@on-search="onSearch"
		>
		</rules-list>
		<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			:value-disabled="valuesDisabled"
			@run-action="runAction"
		/>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="dialog"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{ dialogMessage }}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<v-btn
						type="button"
						@click="closeDialog"
						color="success"
						class="btn-action mr-1 white--text">
						Cancelar
					</v-btn>
					<v-btn
						type="button"
						color="error"
						@click="onDelete"
						class="btn-action ml-1 white--text">
						Eliminar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<action-sidebar
				:title="action.title"
				:value="action.value"
				:width="action.width"
				@close-modal="closeModal"
			>
			<v-layout  wrap ma-2>
				<v-flex xs12 mt-3>
				<label ref="label" for="download-excel">
					<vue-six-four
						ref="vueSixFour"
						id="download-excel"
						hidden
						@vue-six-four="getFile"
					/>
					<v-layout>
						<v-flex xs12 mr-2 class="text-right" >
							<v-btn
								color="success"
								class="btnLoadExcel white--text"
								@click="downloadRules"
							>
								Descargar Plantilla
							<v-icon right dark>file_download</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs12 class="container-import">
							<BaseInput
								:height="35"
								label="Adjuntar excel"
								v-model="excelName"
								required
								class="pr-4"
							>
								<span slot="error" class="caption error--text" v-if="!$v.model.base64.required">
									Es necesario importar un archivo excel
								</span>
							</BaseInput>
							<button class="btn-import" @click="showDialog">
								<img src="/static/img/actions-list/excel.svg" alt="importar excel">
							</button>
						</v-flex>
					</v-layout>
				</label>
			</v-flex>
			<section class="modal-filter-footer">
			<modal-sidebar-button
				success-text="Aceptar"
				@cancel-button-clicked="closeModal"
				@accept-button-clicked="sendAccount"
				:is-loading="$v.$invalid || disabledbutton"
			>
			</modal-sidebar-button>
		</section>
					</v-layout>
			</action-sidebar>
	</section>
</template>

<script>

import actionSidebar from '@/components/shared/action-sidebar';
import actionBar from '@/components/shared/action-bar/action-bar';
import rulesList from '@/components/rules-ats/rules-ats-list';
import { required } from 'vuelidate/lib/validators';
import backButtonRoute from '@/components/shared/back-button-route';
import VueSixFour from 'vue-six-four';
import { mapGetters } from 'vuex';
import permissions from '@/mixins/permissions';

function data() {
	return {
		action: {
			code: '',
			title: '',
			value: false,
			visible: false,
		},
		dialog: false,
		disabledbutton: false,
		model: {
			base64: {
				required,
			},
		},
		dialogMessage: '',
		rows: [],
		excelName: null,
		ruleId: null,
		itemsTotalQuantity: null,
	};
}
function getFile(fileInfo) {
	this.excelName = fileInfo.name.replace(/\s/g, '-');
	const base64data = fileInfo.sixFour.split('base64,');
	this.model.base64 = base64data[1];
}

async function loadData() {
	const response = await this.$http.get(`rules-transactional?customerId=${this.currentSubsidiary.customerId}&subsidiaryId=${this.currentSubsidiary.id}`);
	this.itemsTotalQuantity = Number(response.headers['x-quantity']);
	this.rows = response.data.map(({ id, formula, description, code, startTag }) =>
		({ formula, description, id, code, startTag }),
	);
	return this.rows;
}

async function sendAccount() {
	const method = 'post';
	const url = 'rules-transactional-upload';
	const action = 'creó';
	const newModel = { ...this.model };
	newModel.subsidiaryId = Number(this.currentSubsidiary.id);
	try {
		this.disabledbutton = true;
		await this.$http[method](url, newModel);
		this.disabledbutton = false;
		this.showNotification(`Se ${action} correctamente`);
		this.loadData();
		this.closeModal();
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'RULES_REPEAT') {
				this.showGenericError('No se puede registrar reglas repetidas.');
			} else if (error.data.message === 'FILE_XLSX_ITEM_EMPTY') {
				this.showGenericError('Un item del archivo se encuentra vacío.');
			}
		}
	}
}

async function downloadRules() {
	const body = {
		customerId: this.currentSubsidiary.customerId,
		subsidiaryId:	this.currentSubsidiary.id,
	};
	const response = await this.$http.post('rules-transactional-download-excel', body);
	const byteCharacters = atob(response.data.base64);
	const byteNumbers = [];
	byteCharacters.split('').forEach((char) => {
		byteNumbers.push(char.charCodeAt(0));
	});

	const byteArray = new Uint8Array(byteNumbers);
	const buffer = byteArray.buffer;

	// Crear un Blob a partir del ArrayBuffer
	const blob = new Blob([buffer], { type: 'application/octet-stream' });

	// Crear un objeto URL para descargar el archivo
	const url = URL.createObjectURL(blob);

	// Crear un enlace (link) para la descarga
	const link = document.createElement('a');
	link.href = url;
	link.download = 'reglas_contables_ats.xlsx'; // Cambia el nombre del archivo según desees

	// Simular un clic para iniciar la descarga
	link.click();

	// Revocar el objeto URL para liberar recursos del navegador
	URL.revokeObjectURL(url);
}

function closeDialog() {
	this.dialog = false;
	this.dialogMessage = '';
	this.ruleId = null;
}

function closeModal() {
	this.action.value = false;
	this.action.title = '';
	this.action.code = '';
}
function showDialog() {
	this.$refs.label.click();
}


function clickIcon({ action, row }) {
	// Guarda de seguridad: no permite editar/eliminar sin permiso.
	if (action === 'edit' && !this.canEdit) return;
	if (action === 'delete' && !this.canDelete) return;
	if (action === 'edit') {
		const { id } = row;
		this.goTo('rules-ats-edit', { params: { id }, query: this.$route.query });
	} else if (action === 'delete') {
		this.openConfirmation(row);
	}
}

async function created() {
	await loadData.call(this);
}

function customerId() {
	return Number(this.$route.query.customerId);
}

async function onDelete() {
	try {
		await this.$http.delete(`rules-transactional/${this.ruleId}`);
		this.showNotification('La regla ha sido eliminada correctamente.');
		this.closeDialog();
		this.params.page = 1;
		this.currentPage = 1;
		await loadData.call(this);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			if (err.data.message === 'RULE_NOT_FOUND') {
				this.showGenericError('Regla no encontrada.');
			} else if (err.data.message === 'DELETE_RULE_DEFINITION_INVALID') {
				this.showGenericError('La regla no puede ser eliminada por estar asignada a una definición.');
			}
		}
	}
}

async function onPage(page) {
	this.params.page = page;
	this.currentPage = page;
	await loadData.call(this);
}

async function onSearch(value) {
	this.params.page = 1;
	this.$set(this.params, 'search', value || null);
	await loadData.call(this);
}

function openConfirmation({ id, description }) {
	this.ruleId = id;
	this.dialogMessage = `¿Desea eliminar la regla ${description} del listado?`;
	this.dialog = true;
}

function runAction({ code }) {
	if (code === 'rules-new-ats') {
		this.goTo('accounting-rules-ats-new');
	} else if (code === 'rule-automatic-by-excel') {
		this.action.title = 'Importar Reglas Ats';
		this.action.width = 350;
		this.action.value = true;
	}
}

function valuesDisabled() {
	const userI = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const notFranchise = userI && (userI.company.franchise === null || userI.company.franchise === 0);
	const fatherFranchise = userI && userI.company
		&& userI.company.franchise
		&& userI.subsidiary.father
		? userI.company.franchise === 1 && userI.subsidiary.father === 1 : false;
	return [
		{ code: 'rule-automatic-by-excel', disabled: (!notFranchise && !fatherFranchise) },
		{ code: 'rules-new-ats', disabled: (!notFranchise && !fatherFranchise) },
	];
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}


function title() {
	return `${this.$route.query.name} / ${this.$route.meta.title}`;
}

function currentSubsidiary(newSub) {
	const { id, name, customerId: idCustomer } = newSub;
	this.goTo(
		'accouting-ats-rules',
		{
			params: { customerId: idCustomer, subsidiaryId: id },
			query: { subsidiaryId: id, customerId: idCustomer, name },
		},
	);
}
function validations() {
	const validation = {
		model: {
			base64: {
				required,
			},
		},
	};
	return validation;
}

function routeHandler() {
	this.params.subsidiaryId = this.subsidiaryId;
	loadData.call(this);
}

export default {
	name: 'page-rules',
	mixins: [permissions],
	created,
	components: {
		actionBar,
		rulesList,
		backButtonRoute,
		actionSidebar,
		VueSixFour,
		BaseInput: () => import('@/components/shared/inputs/base-input'),
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		customerId,
		subsidiaryId,
		title,
		valuesDisabled,
	},
	data,
	methods: {
		clickIcon,
		closeModal,
		closeDialog,
		downloadRules,
		onDelete,
		sendAccount,
		onPage,
		getFile,
		showDialog,
		onSearch,
		openConfirmation,
		routeHandler,
		runAction,
	},
	watch: {
		currentSubsidiary,
		'$route.params': routeHandler,
	},
	validations,
};
</script>
<style lang="scss" scoped>
.text-right {
  text-align: center;
}
.container-import {
		position: relative;

		.btn-import {
			background: #03A89E;
			border-radius: 0 5px 5px 0;
			height: 35px;
			padding: 5px 7px 5px 0;
			position: absolute;
			right: 0;
			top: 16px;
			width: 51px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/atsRules/ats-rules.vue